const SET_TABSVIEW = 'SET_TABSVIEW'
const DEL_TABSVIEW = 'DEL_TABSVIEW'
const CLEAR_TABSVIEW = 'CLEAR_TABSVIEW'

const tabsview = {
	state: {
		visitedTabsView: [],
		keepAliveList: [],
		pageQuery: []
	},
	mutations: {
		[SET_TABSVIEW](state, view) {
			if (!state.visitedTabsView.find((n) => n.path === '/')) {
				state.visitedTabsView.push({
					name: '首页',
					path: '/'
				});
				state.keepAliveList.push(view.name);
			}
			if (state.visitedTabsView.find((n) => n.path === view.path)) {
				return
			}
			state.keepAliveList.push(view.name);
			state.visitedTabsView.push({
				name: view.meta.title,
				path: view.path,
				page: view.name
			})
			
		},
		[DEL_TABSVIEW](state, view) {
			for (let [i, v] of state.visitedTabsView.entries()) {
				if (v.path === view.path || v.name === view.name) {
					state.visitedTabsView.splice(i, 1)
					state.keepAliveList.splice(i, 1)
					
					//console.log(view)
					var pageQuery = [];
					try {
						pageQuery = JSON.parse(sessionStorage.getItem('PAGEQUERY'));
						if (!pageQuery)
							pageQuery = [];
					} catch (error) {
						pageQuery = [];
					}
					var findIndex = pageQuery.findIndex(function(item) {
						return item.page == view.page;
					})
					if (findIndex >= 0) {
						pageQuery.splice(findIndex, 1)
						state.pageQuery = pageQuery;
						sessionStorage.setItem('PAGEQUERY', JSON.stringify(pageQuery));
					}
				}
			}
		},
		[CLEAR_TABSVIEW](state, view) {
			state.visitedTabsView = [];
		},
		['PAGEQUERY']: (state, data) => {
			var pageQuery = [];
			try {
				pageQuery = JSON.parse(sessionStorage.getItem('PAGEQUERY'));
				if (!pageQuery)
					pageQuery = [];
			} catch (error) {
				pageQuery = [];
			}
			var findIndex = pageQuery.findIndex(function(item) {
				return item.page == data.page;
			})
			if (findIndex >= 0) {
				pageQuery[findIndex] = data;
			} else {
				pageQuery.push(data)
			}
			state.pageQuery = pageQuery;
			sessionStorage.setItem('PAGEQUERY', JSON.stringify(pageQuery));
		}
	},
	actions: {
		// 添加一个新的tabsView
		addVisitedTabsView({
			commit
		}, view) {
			commit(SET_TABSVIEW, view)
		},
		clearVisitedTabsView({
			commit
		}, view) {
			commit(CLEAR_TABSVIEW, view)
		},
		// 关闭一个tabsView
		delVisitedTabsView({
			commit,
			state
		}, view) {
			return new Promise((resolve, reject) => {
				commit(DEL_TABSVIEW, view)
				resolve([...state.visitedTabsView])
			})
		}
	},
	getters: {
		visitedTabsView: state => state.visitedTabsView,
		keepAliveList: state => state.keepAliveList,
		getPageQuery: state => (page) => {
			var pageQuery = [];
			try {
				pageQuery = JSON.parse(sessionStorage.getItem('PAGEQUERY'));
				if (!pageQuery)
					pageQuery = [];
			} catch (error) {
				pageQuery = [];
			}
			var find = pageQuery.find(function(item) {
				return item.page == page;
			})
			if (find)
				return find.id;
			else
				return 0;
		}
	}
}

export default tabsview
